import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Paginator } from "primereact/paginator";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import api from "../../api/axios";
import moment from "moment";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap-daterangepicker";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { Badge } from "primereact/badge";

const CreditTransactions = () => {
    const pickerRef = useRef(null);

    const [transactions, setTransactions] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const limit = 8;

    const [dateRange, setDateRange] = useState({
        start_date: null,
        end_date: null,
    });

    /* ---------------- Date Picker ---------------- */
    useEffect(() => {
        if (!pickerRef.current) return;

        const $picker = $(pickerRef.current);

        $picker.daterangepicker(
            {
                autoUpdateInput: false,
                opens: "left",
                showDropdowns: true,
                linkedCalendars: false,
                locale: {
                    format: "YYYY-MM-DD",
                    cancelLabel: "Clear",
                },
            }
        );

        $picker.on("apply.daterangepicker", (ev, picker) => {
            const start = picker.startDate.format("YYYY-MM-DD");
            const end = picker.endDate.format("YYYY-MM-DD");

            pickerRef.current.value = `${start} - ${end}`;

            setDateRange({
                start_date: start,
                end_date: end,
            });

            setPage(1);
        });

        $picker.on("cancel.daterangepicker", () => {
            pickerRef.current.value = "";

            setDateRange({
                start_date: null,
                end_date: null,
            });

            setPage(1);
        });

        return () => {
            $picker.data("daterangepicker")?.remove();
            $picker.off();
        };
    }, []);

    /* ---------------- Fetch API ---------------- */
    const fetchTransactions = async (pageNo = 1) => {
        setLoading(true);
        try {
            const res = await api.get(
                `/customerProfileRoutes/customer/credit-transactions`,
                {
                    params: {
                        page: pageNo,
                        limit,
                        start_date: dateRange.start_date,
                        end_date: dateRange.end_date,
                    },
                }
            );

            if (res.data.success) {
                setTransactions(res.data.data);
                setTotalRecords(res.data.totalRecords);
            }
        } catch (err) {
            console.error("Credit transactions fetch failed", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions(page);
    }, [page, dateRange]);

    return (
        <>
            <Row className="mx-0 breadcrumb_part">
                <Col md={12} className="prof_title mb-4 p-0">
                    <h4>Credit Transactions</h4>
                </Col>

                <Col md={12} className="p-0 userDashtab">
                    {/* ---------------- Filters ---------------- */}
                    <div className="d-flex justify-content-end align-items-center gap-2 w-100 filterpart mb-3">
                        <span className="text-secondary">Filter by</span>

                        <input
                            ref={pickerRef}
                            type="text"
                            className="form-control"
                            placeholder="Select date range"
                            style={{ width: "220px" }}
                            readOnly
                        />

                       {/* <IconField iconPosition="left" style={{ width: "180px" }}>
                            <InputText placeholder="Search..." className="ps-5" disabled />
                        </IconField>*/}
                    </div>

                    {/* ---------------- Table ---------------- */}
                    <div className="table-wrapper invoice-table">
                        <Table className="custom-table">
                            <Thead className="sticky-thead">
                                <Tr>
                                    <Th>Date</Th>
                                    <Th>Type</Th>
                                    <Th>Source</Th>
                                    <Th>Reference</Th>
                                    <Th>Credits</Th>
                                    <Th>Balance After</Th>
                                </Tr>
                            </Thead>

                            <Tbody>
                                {!loading && transactions.length === 0 && (
                                    <Tr>
                                        <Td colSpan="6" className="text-center">
                                            No transactions found
                                        </Td>
                                    </Tr>
                                )}

                                {transactions.map((tx, index) => (
                                    <Tr key={tx.transaction_id} className={`table-row ${index === 0 ? "highlight-row" : ""}`}>
                                        <Td>{moment(tx.createdAt).format("DD/MM/YYYY")}</Td>

                                        <Td>
                                            <Badge
                                                value={tx.type.toUpperCase()}
                                                severity={tx.type === "credit" ? "success" : "danger"}
                                            />
                                        </Td>

                                        <Td>{tx.source.replace(/_/g, " ")}</Td>
                                        <Td>{tx.reference_name || "-"}</Td>
                                        <Td>{tx.amount}</Td>
                                        <Td>{tx.balance_after}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>

                    {/* ---------------- Pagination ---------------- */}
                    <Paginator
                        first={(page - 1) * limit}
                        rows={limit}
                        totalRecords={totalRecords}
                        onPageChange={(e) => setPage(e.page + 1)}
                    />
                </Col>
            </Row>
        </>
    );
};

export default CreditTransactions;